import PropTypes from "prop-types";
import React, { Component } from "react";
import Dialog from "./dialog";
import Button from "components/form/flat-button";
import Globalize from "globalize";
import TextField from "../form/text-field";
import { Form } from "formsy-react";
import { DATATEST } from "constants/integration";

/** @augments {Component<any, any>} */
export default class PromptDialog extends Component {
    static propTypes = {
        open: PropTypes.bool.isRequired,
        onSubmit: PropTypes.func.isRequired,
        onCancel: PropTypes.func.isRequired,
        contentStyle: PropTypes.object,
        bodyStyle: PropTypes.object,
        placeholder: PropTypes.string,
        defaultValue: PropTypes.string,
        requiredErrorText: PropTypes.string,
        validations: PropTypes.string,
        validationError: PropTypes.string,
        submitting: PropTypes.bool,
        textFieldLabel: PropTypes.string,
    };

    static defaultProps = {
        defaultValue: "",
        submitting: false,
    };

    constructor(props) {
        super(props);
        this.state = {
            value: props.defaultValue,
        };
        this.handleSubmitButtonTap = this.handleSubmitButtonTap.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleTextFieldChange = this.handleTextFieldChange.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.open !== nextProps.open) {
            this.setState({ value: nextProps.defaultValue });
        }
    }

    handleSubmit() {
        const { onSubmit } = this.props;
        const { value } = this.state;
        onSubmit(value);
    }

    handleTextFieldChange(e, value) {
        this.setState({ value });
    }

    handleSubmitButtonTap() {
        this._form.submit();
    }

    render() {
        const {
            children,
            onCancel,
            contentStyle,
            bodyStyle,
            placeholder,
            title,
            requiredErrorText,
            validations,
            validationError,
            submitting,
            textFieldLabel,
            ...props
        } = this.props;

        return (
            <Dialog
                {...props}
                title={title}
                modal={true}
                onRequestClose={onCancel}
                contentStyle={Object.assign({ maxWidth: "360px" }, contentStyle)}
                bodyStyle={Object.assign({ padding: title ? "0px 24px 4px" : "24px 24px 4px" }, bodyStyle)}
                actions={[
                    <Button
                        key="cancel"
                        data-test={DATATEST.MODAL_PROMPT_CANCEL}
                        label={Globalize.formatMessage("Cancel")}
                        style={{ marginRight: "24px" }}
                        onClick={onCancel}
                    />,
                    <Button
                        key="submit"
                        data-test={DATATEST.MODAL_PROMPT_CONFIRM}
                        label={Globalize.formatMessage("Submit")}
                        disabled={submitting}
                        primary={true}
                        onClick={this.handleSubmitButtonTap}
                    />,
                ]}
            >
                <Form onValidSubmit={this.handleSubmit} noValidate autoComplete="off" ref={(ref) => (this._form = ref)}>
                    <TextField
                        placeholder={placeholder}
                        name="input"
                        dataTest={DATATEST.MODAL_PROMPT_INPUT}
                        fullWidth={true}
                        requiredErrorText={requiredErrorText}
                        onChange={this.handleTextFieldChange}
                        validations={validations}
                        validationError={validationError}
                        allowWhitespace={true}
                        large={true}
                        label={textFieldLabel}
                        defaultValue={this.state.value}
                        required={true}
                    />
                </Form>
                {children}
            </Dialog>
        );
    }
}
